<div class="landing-page-sec">
  <nav class="navbar navbar-inverse navbar-fixed-top">
    <div class="container">
      <div class="col-xs-12 pad0">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false"
            aria-controls="navbar">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <a class="navbar-brand" href="#">
            <img src="assets/img/SG-landing-page-logo.png" />
          </a>
        </div>
        <div id="navbar" class="navbar-collapse collapse" aria-expanded="false" style="height: 1px;">
          <ul class="nav navbar-nav navbar-right">
            <li>
              <a (click)="navigateToSignup()" target="_blank" class="btn btn-creat-acc">Create Free Account / Log In</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
  <div class="main-sec">
    <section class="overview-sec view-bg">
      <div class="container-fluid">
        <div class="col-xs-12 pad0">
          <div class="title-sec text-center">
            <h2 class="">2019 Fantasy Football Is Here!
            </h2>
          </div>

          <div class="tbl-sec">
            <div class="col-md-5 col-sm-6 col-sm-12 lft-sec tbl-cell">
              <p class="text-left"> Fantasy Football is BACK and 2019 is going to be an action-packed year.  To compete at the highest level you need Two Things… Information & Opportunity.  Reliable data (Player mock draft positions, consensus charts, matchup charts, etc.) is crucial and hard find from trustworthy sources. There are so many resources on the market today and choosing the RIGHT one can be difficult as well as time consuming. Finding the right opportunity to maximize your knowledge of Fantasy Football is yet another challenge. </p>
              <p class="text-left">Every week you are accumulating hours of research to set the best possible Fantasy Football line-up but once your roster has been selected, are you maximizing your opportunity?
                <b>
                  <u>For these reasons The IDP Guys and StatementGames Inc. have combined forces in an effort to give Fantasy Football Fans reliable information & opportunity.

                  </u>
                </b>
              </p>
            </div>
            <div class="col-md-7 col-sm-6 col-sm-12  ximg-sec text-center tbl-cell signin-div nfl-landing sign-bg-img" style="vertical-align: top;">
              <img src="assets/img/logo-fantasy.png" width="200" style="margin-bottom:10px;" />
              <div class="clearfix"></div>
              <iframe width="520" height="300" class="vd-frame" src="https://www.youtube.com/embed/laF7uyeVDhI" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
              <div class="clearfix"></div>
              <p style="line-height: 24px;margin-top:10px; font-weight: bold;">Signing up for StatementGames is simple.
                <br>You can even do so with your Google Account. </p>
            </div>
          </div>
          <br>
          <div class="text-center">
            <a (click)="navigateToSignup()" target="_blank" class="btn btn-creat-acc minwd245">Create Free Account / Log In</a>
          </div>
        </div>
      </div>
    </section>
    <section class="fantasy-sports xbg-red txt-blk">
      <div class="container-fluid">
        <div class="col-xs-12 pad0">
          <div class="title-sec text-center">
            <h2 class="">ABOUT WWW.IDPGUYS.ORG</h2>
            <div class="clearfix"></div>

          </div>
          <div class="col-md-6 col-sm-12 cnt-sec col-md-push-6">
            <p class=" text-left">IDP Guys started out as a podcast from a pair of roommates, and in the last three years has grown into the number 1 resource for IDP and defensive football information and data. Started by Jon, Sean and Nathan their staff now includes over 20 of the best fantasy football minds.

            </p>

            <p class=" text-left">Taking this amazing team forward, they have developed the Dynasty Football Digest. Their answer to putting their talent to work on the offensive side of the ball. This new site, launched in 2019 offers the same great data and tools for your dynasty leagues.
            </p>
            <p class="text-left">Find all the data, articles, and tools at<a href="https://www.idpguys.org/" target="_blank">www.idpguys.org</a> and <a href="https://www.DynastyFootballDigest.com/" target="_blank">www.DynastyFootballDigest.com.</a></p>
            <div class="clearfix"></div>
            <br>

          </div>

          <div class="col-md-6 col-sm-12 text-center ximg-sec col-md-pull-6 text-center">
            <div class="text-center">
              <img src="assets/img/IDPGuys.png" />
            </div>
            <br>
            <div class="text-left col-md-7 col-sm-11 col-sm-sm-12 pad0 fltnon">
              <h4>Step1 -
                <a (click)="navigateToSignup()" target="blank" class="btn btn-creat-acc-wht minwd245">Create Free Account / Log In</a>
              </h4>

              <h4>Step2 -
                <a (click)="navigateToSignup()" class="btn btn-creat-acc-wht minwd245 bg-wht">Buy Subscription</a>
              </h4>

            </div>
          </div>

        </div>
      </div>
    </section>

    <section class="our-offers pad-sec" style="background: #fceced">
      <div class="container">
        <div class="col-xs-12">

          <div class="title-sec text-center">
            <h2 class="">About StatementGames Inc. </h2>
          </div>
          <p class="">
            <a href="https://www.statementgames.com/" target="_blank">www.statementgames.com</a> is a Patent Pending Fantasy Football / Fantasy Sports gaming platform that brings
            a unique twist to the sports community. An overview of how we are different can be found in the video below.
            By combing simplicity with innovation STATEMENTGAMES has been highlighted on ABC, CBS, NBC &amp; FOX. New members
            have the ability to create a FREE account on
            <a href="https://www.statementgames.com/" target="_blank">www.statementgames.com</a> at any time but the platform is a Virtual Coin based platform. The objective of all
            community members is in competing for and acquiring as many virtual coins as possible. Then, when enough StatementGames
            coins have been acquired – exchange your coins for $ gift cards of your choice. Hundreds of brands to choose
            from including Amazon, Domino’s, Google Play, NFL Shop, Target, Xbox, AMC Theatres, Fanatics, App Store &amp;
            iTunes, Nike, Walmart, etc.</p>
        </div>
      </div>
    </section>


    <section class="our-offers pad-sec">
      <div class="container">
        <div class="col-xs-12 pad0">

          <div class="title-sec text-center">
            <h2 class="">DISCOUNTED 2019 FANTASY FOOTBALL OFFER</h2>
          </div>


          <h4 style="margin-top:15px; text-align: center;">
            <strong>
              <span class="txt-bg text-center">Killing 2 Birds With 1 Stone - What You Are Getting With A 1 IDP Guys & StatementGames Inc. Fantasy Sports Subscription.
              </span>
              <!--– The VIP BigGuy Fantasy Sports &amp; StatementGames
Subscription – What You Get For ONLY $59.49.-->
            </strong>
          </h4>
          <ul class="point-list lst-bg-non">
            <li>1)Defensive Data - $12 Retail Value: Consensus rankings of over 200 defensive players, Monthly ADP for IDP and IDP and Offensive leagues, Player Ratings for the coming season, access to a chat room with other subscribers and writers.
            </li>
            <li>1)Offensive Data - $12 Retail Value: Consensus rankings for nearly 300 dynasty players, Monthly ADP for super flex dynasty, Player Ratings for the coming season, and access to a chat room with other subscribers and writers.</li>
            <li>2) M, L or XL IDP Guys & StatementGames Inc. T-shirt - $25 Value
            </li>
            <li>3) 10% Off Discount code for all future purchases from idpguys.org</li>
            <li>4) A $5 Donation will be made to the Jimmy V Fondation for Cancer Research - $5 Value
            </li>
            <li>5) Free
              <a href="https://www.statementgames.com/" target="_blank">www.statementgames.com</a> account. With your account you will receive 60 FREE StatementGames Coins upon account
              sign up.</li>
            <li>6) 100 StatementGames Coins will be added to your account monthly for 12 consecutive months.
            </li>
            <li>7) Your 100 monthly coins COUNT towards “COINS EARNED” on the StatementGames LEADERBOARD.Your ROI is dependent on how well you can make picks and play “StatementGames”.  Your coins can be exchanged for hundreds of REWARDS!

            </li>
          </ul>
          <h4 class="text-center value-txt">
            <strong>*** TOTAL VALUE Of $137.88 YOURS FOR ONLY $94.88 – OVER 30% Off Current Retail Rate***</strong>
          </h4>
          <br>
          <div class="text-left col-md-4 col-sm-7 col-sm-12 pad0 fltnon">
            <h4>Step1 -&nbsp;&nbsp;
              <a (click)="navigateToSignup()" target="blank" class="btn btn-creat-acc-wht minwd245">Create Free Account / Log In</a>
            </h4>

            <h4>Step2 -&nbsp;&nbsp;
              <a (click)="navigateToSignup()" class="btn btn-creat-acc-wht minwd245 bg-wht">Buy Subscription</a>
            </h4>

          </div>
          <!--  <div class="text-center">
         <a href="https://www.statementgames.com/#/landing/signin" target="_blank" class="btn btn-creat-acc-wht">Create Free Account / Log In</a>&nbsp;&nbsp;<a href="#" class="btn btn-creat-acc-wht bg-wht">Buy Subscription</a>

			</div>  -->
        </div>
      </div>
    </section>








    <section class="should-buy pad-sec ">
      <div class="container">
        <div class="col-xs-12 pad0">
          <div class="title-sec text-center">
            <h2 class="">10 Reasons Why You Should Buy Now</h2>
          </div>
          <div class="col-sm-6">
            <ul class="point-list">
              <li>
                <span>1</span>The IDP Guys are national recognized as Offensive & Defensive Fantasy Football experts.  Their data, charts and models have helped thousands compete at a higher Fantasy Football level.</li>
              <li>
                <span>2</span>Time is $$$ - Cut your research time in HALF with a IDP Guys / StatementGames Inc.
                Subscription. All the data that you can ever need in drafting an IDP Fantasy Football Team,, analyzing players and setting lineups at your fingertips.
              </li>
              <li>
                <span>3</span>Reliability – If you belong to a IDP or traditional 10 or 12-person Fantasy Football league you will outperform OVER 70% of your league by fully utilizing your IDP Guys / StatementGames Inc. Subscription.
              </li>
              <li>
                <span>4</span>You are getting the tools & research that you need while supporting a great cause.  $5 will be donated to support cancer research.
              </li>
              <li>
                <span>5</span>The information that you will gleam from idpguys.org is going to assist you in other areas of gaming and in making OVER / UNDER Prop Picks on StatementGames. More opportunities to compete & WIN.</li>

            </ul>
          </div>
          <div class="col-sm-6">
            <ul class="point-list">
              <li>
                <span>6</span>On
                <a href="https://www.statementgames.com/" target="_blank">www.statementgames.com,</a> 100 Coins retail for $6.99 – You are getting 1,200 coins!

              </li>
              <li>
                <span>7</span>Having 100 StatementGames Coins added to your account monthly gives subscribers a distinct competitive advantage on the StatementGames LEADERBOARD Vs Non-Subscribers.
              </li>
              <li>
                <span>8</span>90% of IDP Guys / StatementGames Inc. subscribers WIN more coins over the course of a given month on
                <a href="https://www.statementgames.com/" target="_blank">www.statementgames.com</a> than NON-Subscribers. Coins that can be exchanged for $ E-Gift Cards.
              </li>
              <li>
                <span>9</span>If you did NOTHING with your www.statementgames.com account you would be able to exchange your 1,200 coins for a $12 E-Gift Card via StatementGames REWARDS. Hundreds of brands to choose from including Amazon, Domino’s, Google Play, NFL Shop, Target, Xbox, AMC Theatres, Fanatics, App Store & iTunes, Nike, Walmart, etc.

              </li>
              <li>
                <span>10</span>At the end of your IDP Guys / StatementGames Inc. subscription, IF YOU ARE NOT SATISIFED with our service we will REFUND your $ no questions asked.
              </li>
            </ul>
          </div>

          <div class="text-left col-md-4 col-sm-7 col-sm-12 pad0 fltnon">
            <h4>Step1 -&nbsp;&nbsp;
              <a (click)="navigateToSignup()" target="blank" class="btn btn-creat-acc-wht minwd245">Create Free Account / Log In</a>
            </h4>

            <h4>Step2 -&nbsp;&nbsp;
              <a href="#" class="btn btn-creat-acc-wht minwd245 bg-wht">Buy Now</a>
            </h4>

          </div>
          <!--    <div class="text-center">
         <a href="https://www.statementgames.com/#/landing/signin" target="_blank" class="btn btn-creat-acc-wht">Create Free Account / Log In</a>&nbsp;&nbsp;<a href="#" class="btn btn-creat-acc-wht bg-wht">Buy Now</a>

			</div> -->

        </div>

      </div>
    </section>


    <section class=" testimonial-sec pad-sec bgnon">
      <div class="container">
        <div class="title-sec text-center">
          <h2 class="">
            TESTIMONIAL
            </h2>
        </div>

        <div class="logo-icons-wins">
          <ul class="list-inline">
            <li>
              <img alt="" src="assets/img/wings.png">
            </li>
            <li>
              <div class="social-section">
                <i aria-hidden="true" class="fa fa-twitter"></i>
                <i aria-hidden="true" class="fa fa-facebook"></i>
              </div>
            </li>
            <li class="test-email">
              <h4 class="splash-page__tweets-handle">@Statementgames</h4>
            </li>
          </ul>
        </div>


        <!-- <div class="owl-carousel testimonials-carousel"> -->
        <div class="row">
          <div class="col-sm-4">
            <div class="testimonial-item">
              <div class="col-xs-12">
                <div class=" testimonial-cnt">
                  <img src="assets/img/dynastyjunkieff.png" class="pro-logo" width="73" />
                  <h3>
                    <a href="https://twitter.com/dynastyjunkieff" target="_blank">@DYNASTY JUNKIEFF</a>
                  </h3>
                  <div class="clearfix"></div>
                  <p>I really enjoy playing StatementGames!  Their concept is so unique.  Now I am looking forward to taking advantage of the data I get from the IDP guys to master my Fantasy Football league.
                  </p>
                  <div class="text-center">
                    <a href="#" data-toggle="modal" data-target="#myModal1" class="btn btn-creat-acc">Read more</a>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="testimonial-item">
              <div class="col-xs-12">
                <div class=" testimonial-cnt">
                  <img src="assets/img/dynastyron.png" class="pro-logo" />
                  <h3>
                    <a href=" https://twitter.com/dynastyron" target="_blank">@DYNASTYRON</a>
                  </h3>
                  <div class="clearfix"></div>
                  <p>Finally two organizations that simply get it!  Keep up the great work guys… I found traditional Fantasy Football to be a little stale.  You guys have brought me back into the fold with this offer. </p>
                  <div class="text-center">
                    <a href="#" data-toggle="modal" data-target="#myModal3" class="btn btn-creat-acc">Read more</a>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="testimonial-item">
              <div class="col-xs-12">
                <div class=" testimonial-cnt">
                  <img src="assets/img/jdefeo91.jpg" class="pro-logo" />
                  <h3>
                    <a href="https://twitter.com/JDEFEO91" target="_blank">@JDEFEO91</a>
                  </h3>
                  <div class="clearfix"></div>
                  <p>I am getting a great service while supporting a great cause.  This service is a no brainer. </p>
                  <div class="text-center">
                    <a href="#" data-toggle="modal" data-target="#myModal2" class="btn btn-creat-acc">Read more</a>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  <footer>
    <div class="container">
      <div class="row">
        <div class="col-sm-5">
          <div class="address-sec">
            <img src="assets/img/SG-landing-page-logo.png" width="280px" />
            <address>
              <p>
                <i class="fa fa-map-marker" aria-hidden="true"></i>&nbsp;New York, USA.</p>
              <p>
                <a href="#">
                  <i class="fa fa-envelope" aria-hidden="true"></i>&nbsp;marketing@statementgames.com</a>
              </p>
              <!--  <p><a href="#"><i class="fa fa-phone" aria-hidden="true"></i>&nbsp;1-833-232-1702</a></p>-->
            </address>
          </div>
        </div>
        <div class="col-sm-4 ftr-link">
          <h4>Our Links</h4>
          <ul>
            <li *ngFor="let footer of footers" (click)="loadFooterContent(footer)">
              <a href="javascript:void(0);">{{footer.title}}</a>
            </li>

          </ul>
        </div>
        <div class="col-sm-3 social-sec">
          <h4>Social Connect:</h4>
          <ul class="social-links list-inline">
            <li>
              <a href="https://www.facebook.com/StatementGames/" target="_blank">
                <i class="fa fa-facebook" aria-hidden="true"></i>
              </a>
            </li>
            <li>
              <a href="https://twitter.com/statementgames" target="_blank">
                <i class="fa fa-twitter" aria-hidden="true"></i>
              </a>
            </li>
            <!--<li><a href="#" target="_blank"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>-->
            <!--       <li><a href="https://plus.google.com/104605028988485215379" target="_blank"><i class="fa fa-google-plus" aria-hidden="true"></i></a></li>-->
            <li>
              <a href="https://www.instagram.com/statementgames/" target="_blank">
                <i class="fa fa-instagram" aria-hidden="true"></i>
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/channel/UCZtETt-wK0OnF_AHbQ5RRhQ?view_as=subscriber" target="_blank">
                <i class="fa fa-youtube" aria-hidden="true"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="footer-btm">
      <div class="container text-center">
        <p>2019 StatementGames Inc.</p>
      </div>
    </div>
  </footer>
</div>
<script src="https://ajax.googleapis.com/ajax/libs/jquery/1.11.2/jquery.min.js"></script>
<script src="js/bootstrap.min.js"></script>
<script src="js/owl.carousel.min.js"></script>

<div class="model-popup-video">
  <div id="myModal" class="modal fade" role="dialog">
    <div class="modal-dialog">

      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">×</button>
        </div>
        <div class="modal-body">
          <iframe width="100%" height="295" src="https://www.youtube.com/embed/laF7uyeVDhI" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </div>
</div>


<div id="myModal1" class="modal fade playnowmodel" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <div class="col-sm-2 text-center">
          <img src="assets/img/Realkuj.jpg" class="ply-img"> </div>
        <div class="col-sm-9">
          <h1 class="ply-now-head" style="margin-top:0px;">@Joseph Haggan

          </h1>
        </div>
        <div class="content-play">
          <p class="play-bodysec">
            I really enjoy playing StatementGames!  Their concept is so unique.  Now I am looking forward to taking advantage of the data I get from the IDP guys to master my Fantasy Football league.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>


<div id="myModal2" class="modal fade playnowmodel" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <div class="col-sm-2 text-center">
          <img src="assets/img/TPE.jpg" class="ply-img"> </div>
        <div class="col-sm-9">
          <h1 class="ply-now-head" style="margin-top:0px;">@Charlotte Ayres

          </h1>
        </div>
        <div class="content-play">
          <p class="play-bodysec">
            Finally two organizations that simply get it!  Keep up the great work guys… I found traditional Fantasy Football to be a little stale.  You guys have brought me back into the fold with this offer.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="myModal3" class="modal fade playnowmodel" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <div class="col-sm-2 text-center">
          <img src="assets/img/Eroll.jpg" class="ply-img"> </div>
        <div class="col-sm-9">
          <h1 class="ply-now-head" style="margin-top:0px;">@Brian Pepe

          </h1>
        </div>
        <div class="content-play">
          <p class="play-bodysec">
            Finally two organizations that simply get it!  Keep up the great work guys… I found traditional Fantasy Football to be a little stale.  You guys have brought me back into the fold with this offer.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
